import React from 'react'
import { FavTeamsSection } from '../../styleComponents/index'
import { FavouriteTeams } from '../../components'

export const FavouriteTeamsPage = () => {
    return (
        <FavTeamsSection>
            <FavouriteTeams />
        </FavTeamsSection>
    )
}